module.exports = __webpack_public_path__ + "img/popup.4ffece3b.png";